import script from "./expiredLicenseForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./expiredLicenseForm.vue?vue&type=script&lang=ts&setup=true"

import "./expiredLicenseForm.vue?vue&type=style&index=0&id=2fe9cfda&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe9cfda"]])

export default __exports__